import { render } from "./WrongBookPage.vue?vue&type=template&id=6f34961c"
import script from "./WrongBookPage.vue?vue&type=script&lang=js"
export * from "./WrongBookPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__